
function NotFound() {
  return (
    <div className="App">
      <header className="App-header">
       
        <h1>
          NotFound
        </h1>
      
      </header>
    </div>
  );
}

export default NotFound;
